import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

export const languageMap: { [key: string]: string } = {
    en: "English",
    zh_Hans_CN: "Chinese",
    da: "Danish",
    nl: "Dutch",
    fi: "Finnish",
    fr: "French",
    de: "German",
    hi: "Hindi",
    it: "Italian",
    no: "Norwegian",
    ro: "Romanian",
    es: "Spanish",
    tr: "Turkish"
};

i18n.use(Backend)
    .use(initReactI18next)
    .init({
        // log i18n only in development
        debug: import.meta.env.MODE === "development",
        // use base language only (e.g. "en" instead of "en-US") so it matches our folder structure /locales/en/translation.json
        load: "languageOnly",
        lng: "en", // Always default to English regardless of browser settings
        fallbackLng: "en",
        supportedLngs: Object.keys(languageMap),
        nsSeparator: false
    })
    .catch(e => console.log(e));

//ONLY FOR DEBUG TO CATCH MISSING TRANSLATIONS
// const originalT = i18n.t;
// i18n.t = (key, options) => `[i18n] ${originalT(key, options)}`;

export default i18n;

export const handleLanguageChange = (option: string) => {
    i18n.changeLanguage(option).catch(e => console.log(e));
};

export const getCurrentLanguage = () => {
    let currentLanguageCode = i18n.language || "en";
    // all codes are < 2 but by default on first load
    // code is en-CA [code-region] or chinese code is zh_Hans_CN
    // filering chinese out to return en for mapping any other non supported codes 😎
    if (currentLanguageCode.length > 2 && !currentLanguageCode.includes("Hans")) {
        currentLanguageCode = "en";
    }
    const currentLanguageName = languageMap[currentLanguageCode];
    return { label: currentLanguageName, value: currentLanguageCode };
};
